import { Component } from '@angular/core';

@Component({
    selector: 'ajuntament-vall-bas',
    template: require('./ajuntament-vall-bas.component.html'),
})

export class AjuntamentVallBasComponent {    

    constructor() {
    
    }

    navigateURL(url: string) {
        window.open(url, '_blank');
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projects/ajuntament_vall_bas/ajuntament-vall-bas.component.ts
 **/